<template>
    <v-progress-circular v-if="item.status === 'loading'" indeterminate color="primary" />
    <v-icon v-else-if="item.status === 'complete'" color="success" class="status-icon">mdi-check</v-icon>
    <ClModal
        v-else-if="item.status === 'error'"
        v-model="showErrorDialog"
        width="400px"
        class="error-dialog"
    >
        <template #activator="{ on, attrs }">
            <ClButton
                icon
                v-bind="attrs"
                aria-label="View Error"
                color="white"
                class="error-dialog__button"
                :elevation="0"
                v-on="on">
                <v-icon>mdi-alert-outline</v-icon>
            </ClButton>
        </template>
        <v-card>
            <div class="error-dialog__header">
                <v-card-title class="headline error white--text">Error</v-card-title>
                <ClButton
                    class="icon-button"
                    color="white"
                    aria-label="close"
                    :elevation="0"
                    icon
                    @click="showErrorDialog = false"
                >
                    <v-icon>mdi-close</v-icon>
                </ClButton>
            </div>
            <v-container class="error-dialog__body">
                <v-card-subtitle>{{ item.message }}</v-card-subtitle>
                <v-card-actions>
                    <v-spacer />
                    <ClButton color="error" @click="showErrorDialog = false">
                        Close
                    </ClButton>
                </v-card-actions>
            </v-container>
        </v-card>
    </ClModal>
    <v-icon v-else-if="item.status === 'pending'" class="status-icon">mdi-progress-clock</v-icon>
    <div v-else>{{ item.status }}</div>
</template>
<script>
export default {
    name: 'ItemStatus',
    props: {
        item: {
            type: Object,
            required: false,
            defaultValue: {},
        },
    },
    data() {
        return {
            showErrorDialog: false,
        };
    },
};
</script>
<style lang="scss" scoped>
    .error-dialog {
        &__header {
            position: relative;
            .icon-button {
                position: absolute;
                top: 12px;
                right: 12px;
                color: white;
            }
        }
        &__body {
            padding: 0;
            padding-bottom: 8px;
        }
        &__button {
            background-color: var(--v-error-base)
        }
    }
    .status-icon {
        margin-right: 6px;
        margin-left: 6px;
    }
</style>
